import type { FaireProductEntity } from "../../entity_types/product";

export const p_rc3w9mgjtr: FaireProductEntity = {
  token: "p_rc3w9mgjtr",
  type: "product",
  name: "Mañana Hot Sauce - 24 BOTTLES",
  brandToken: "b_cbq5b5q6t2",
  brandName: "Mañana Hot Sauce",
  imageUrl:
    "https://cdn.faire.com/fastly/0721f5d9d759ddbfe5a485eca2963bc63efa0d23f97c8843c982aada594c461c.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9e6dc945aebed0abd797de36828aa649985fd31846994f57cb834413cc2da377.png",
    "https://cdn.faire.com/fastly/042300fed227938231b2fd4af7ce8dd92f40a696a067b21cbf9a20a927529966.png",
    "https://cdn.faire.com/fastly/4a8346aabd797547e3f8896d4e1f704443e4ee8941e56ef4f09137b13b00e1ae.png",
    "https://cdn.faire.com/fastly/b79c4897c52169bc29f1ec4f8981e1ebb9883094728db4eb64cc92f56451236d.png",
    "https://cdn.faire.com/fastly/515211ce00ef574a222848031e4f02474161e69b7c8c35a73a6feb4c7360692a.png",
  ],
  priceDollars: 4.5,
  description:
    "Mañana is a vegan + keto alternative to other sauces which often contain preservatives, additives, sugars, artificial flavors and seed oils.\n\nMañana began in small batches in Miami. Customers loved it, so I continued making it. 5/10 spice level.\n\nMañana is a sauce for people with a romantic and optimistic worldview, a.k.a our motto printed on the bottle: \"For old souls.' With that being said, it can still be enjoyed by everyone.\n\nNo Preservatives | Vegan | Zero Added Sugar | Keto | No Seed Oils | Gluten Free",
  tags: [],
  msrpDollars: 9.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:47:24.658Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
